import * as React from 'react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { initialize } from 'src/actions/help';
import CommonHelp from 'src/components/CommonHelp';
import { useSelector } from 'src/utils';

import { MasterItemCode } from '../utils/MasterData';

/**
 * 受講者ヘルプ
 */
export const ParticipantHelp = () => {
	const dispatch = useDispatch();
	let guides;
	if (localStorage.getItem(MasterItemCode.EM_COOPERATION_MODE) === '1') {
		guides = useSelector(state => state.help.participantEM);
	} else {
		guides = useSelector(state => state.help.participant);
	}
	const init = useMemo(
		() => () => {
			dispatch(initialize());
		},
		[dispatch, initialize]
	);

	return <CommonHelp guides={guides} init={init} />;
};



// WEBPACK FOOTER //
// ./src/containers/Helps.tsx